import React, { useMemo } from "react";
import { SHELL } from "@/api/connectorPackClient";

export default function MissingCredentialChecklist({ connectors }) {
  const missing = useMemo(() => {
    const out = [];
    (connectors || []).forEach((c) => {
      (c.missing_env_keys || []).forEach((k) => out.push({ connector: c.name, env: k, class: c.credential_class }));
    });
    return out;
  }, [connectors]);
  if (!missing.length) return null;
  return (
    <div style={SHELL.panel} data-testid="missing-credential-checklist">
      <h2 style={SHELL.h2}>Missing Credentials Checklist · {missing.length}</h2>
      <table style={{ ...SHELL.table, marginTop: 8 }}>
        <thead><tr><th style={SHELL.th}>Connector</th><th style={SHELL.th}>Env Var</th><th style={SHELL.th}>Credential Class</th></tr></thead>
        <tbody>
          {missing.map((m, i) => (
            <tr key={`${m.connector}-${m.env}-${i}`}>
              <td style={SHELL.td}>{m.connector}</td>
              <td style={SHELL.td}><code>{m.env}</code></td>
              <td style={SHELL.td}>{m.class}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
